import axios from 'axios';
import { isBefore } from 'date-fns';
import { $closest, $find, $findAll, $hide, $qs, $qsa, $setHTML } from 'fxdom/es';
import { each, filter, go, head, html, strMap, zipWithIndexL } from 'fxjs/es';
import { MShopCoreF } from '../../../../../../MShop/Core/F/Function/module/MShopCoreF.js';
import { MShopUtilF } from '../../../../../../MShop/Util/F/Function/module/MShopUtilF.js';
import { UtilF } from '../../../../../../Util/F/Function/module/UtilF.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { customProductHeaderTmpl } from '../../../../../Core/S/Tmpl/custom.js';
import { NessCoreTmplS } from '../../../../../Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessUtilF } from '../../../../../Util/F/Function/module/NessUtilF.js';
import { getProductListSortOptions, NessProductListType } from '../../S/Constant/product.js';
import { NessAppPlusProductS } from '../../S/Function/module/NessAppPlusProductS.js';
import { customFilterCategoryListTmpl } from '../../S/Tmpl/customProduct.js';
import { emptyProductListTmpl, nessProductLazyLoadTmpl } from '../../S/Tmpl/product.js';

const component = 'ness-plus-product-list';
const dropdown_component = 'mshop-comp-dropdown';

export const reRenderProductList = (products) => {
  const products_el = $qs(`.${component}__products`);
  const empty_products_el = $qs(`.${component}__products--empty`);

  $setHTML(
    strMap((product) => nessProductLazyLoadTmpl(product, NessUtilF.isMobile()), products),
    products_el,
  );
  $setHTML(emptyProductListTmpl(), empty_products_el);

  const is_empty = !products?.length;
  products_el.dataset.show = !is_empty;
  empty_products_el.dataset.show = is_empty;

  UtilF.refreshLazyLoad();
};

export const reRenderProductFeatures = (cate_list_id, remaining_timers, frame_el) => {
  const root_el = $qs(`.${component}`);

  // product_list_type 갱신
  const product_list_type = getProductListType(cate_list_id);
  root_el.dataset.type = product_list_type;

  // custom_level 파라미터 갱신
  const url = new URL(window.location.href);
  const customLevel = url.searchParams.get('custom_level');
  if (customLevel) {
    root_el.dataset.custom_level = customLevel;
  }

  // cate_list 갱신
  const cate_list_els = $findAll(`.${component}__cate-list`, root_el);
  each((cate_list_el) => {
    cate_list_el.dataset.selected = cate_list_el.dataset.id == cate_list_id;
  }, cate_list_els);

  // cate_item 갱신
  const cate_item_els = $findAll(`.${component}__cate-item`, root_el);

  go(
    cate_item_els,
    each((cate_item_el) => {
      cate_item_el.dataset.show = cate_item_el.dataset.cate_list == cate_list_id;
      cate_item_el.dataset.selected = false;
    }),
    filter((cate_item_el) => cate_item_el.dataset.show === 'true'),
    head,
    (cate_item_el) => (cate_item_el.dataset.selected = 'true'),
  );

  // 특별판매만 보기 필터 reset
  const limited_checkbox_el = $qs(`.${component}__limited-filter .mshop-core__checkbox__input`, root_el);
  resetCheckbox(limited_checkbox_el);

  // 품절상품 제외 필터 reset
  const soldout_checkbox_el = $qs(`.${component}__soldout-filter .mshop-core__checkbox__input`, root_el);
  resetCheckbox(soldout_checkbox_el);

  // 정렬 드롭다운 reset
  const sort_dropdown_el = $qs(`.${component}__sort-box`, root_el);
  const sort_options = getProductListSortOptions(product_list_type);
  const selected_sort_option = sort_options.length ? head(sort_options) : null;
  $setHTML(
    NessCoreTmplS.dropdown({
      options: sort_options,
      selected_option: selected_sort_option,
      klass: `${component}__dropdown`,
    }),
    sort_dropdown_el,
  );
  initProductListSortDropdown(product_list_type, remaining_timers, frame_el);
};

export const replaceCustomCateList = (custom_products, domain_name) => {
  if (domain_name == null || UtilS.isEmpty(custom_products)) return null;

  const custom_data = NessAppPlusProductS.getCustomData(custom_products, domain_name);
  const product_list_el = $qs('.ness-plus-product-list');

  if (product_list_el == null) return;
  const custom_level = product_list_el.dataset?.custom_level;

  if (custom_level) {
    const custom_product_cate_list_el = $find('.ness-plus-product-list__cate-lists__custom', product_list_el);
    if (custom_product_cate_list_el == null) return;

    const is_mobile = NessUtilF.isMobile();

    let custom_header_tmpl = '';

    if (is_mobile) {
      const toggleSelectionForCustomMenu = () => {
        // Remove 'selected' class from all custom menu items
        $qsa('.custom__header__type-menus__item').forEach((el) => {
          el.classList.remove('selected');
        });

        // Add 'selected' class to matching custom level item
        $qs(
          `.custom__header__type-menus__item[data-custom_level=${custom_level.toUpperCase()}]`,
        )?.classList?.add('selected');
      };

      toggleSelectionForCustomMenu();
    } else {
      // PC 에서는 body 에 헤더 주입
      custom_header_tmpl = customProductHeaderTmpl(is_mobile);
    }

    const custom_cate_list_tmpl = customFilterCategoryListTmpl(
      custom_data.custom_filter_menu_data,
      is_mobile,
    );

    custom_product_cate_list_el.innerHTML = html`${custom_header_tmpl}${custom_cate_list_tmpl}`;
  }
};

const resetCheckbox = (checkbox_el) => {
  checkbox_el.checked = false;
};

export const initProductListSortDropdown = (product_list_type, remaining_timers, frame_el) => {
  const fetch_products_url = {
    all: `/${T.lang}/@api/renewal/product/list/all`,
    recent: `/${T.lang}/@api/renewal/product/list/recent`,
    limit: `/${T.lang}/@api/renewal/product/list/limit`,
    popular: `/${T.lang}/@api/renewal/product/list/popular`,
  };

  MShopCoreF.initDropdown({
    target_el: $qs(`.${component}__sort-box .${dropdown_component}`),
    hooks: {
      onChange: async (e, { value, name }) => {
        // sort 동일한 값 선택
        if (UtilF.parseUrlParams().sort === value) {
          return;
        }

        const params = UtilF.updateAndParseUrlParams({ sort: value });
        const { products } = await axios
          .get(fetch_products_url[product_list_type], { params })
          .then((res) => res.data);
        history.replaceState(null, '', UtilF.updateUrlParams({ sort: value }));
        reRenderProductList(products);
        clearTimers(remaining_timers);
        remaining_timers = initComingSoonRemainingTimer(frame_el);
      },
      onOpenDropdown: (e) => {
        if (MShopUtilF.isMobile()) {
          const dropdown_el = $closest(`.${dropdown_component}`, e.currentTarget);
          MShopCoreF.convertMenuToBottomSheetMo(dropdown_el);
        }
      },
    },
  });
};

export const getProductListType = (cate_list_id) => {
  if (
    [
      NessProductListType.limit,
      NessProductListType.recent,
      NessProductListType.popular,
      NessProductListType.custom,
      NessProductListType.labs,
    ].includes(cate_list_id)
  ) {
    return cate_list_id;
  }
  return 'all';
};

/**
 * Coming Soon 타이머 초기화 함수
 * @param tab_el
 * @return {number[]} timer_ids
 */
export const initComingSoonRemainingTimer = (tab_el) => {
  const remaining_time_els = $qsa(`.app-product-item__remaining-time`, tab_el);
  if (!remaining_time_els.length) {
    return [];
  }

  const timers = new Array(remaining_time_els.length);
  go(
    remaining_time_els,
    zipWithIndexL,
    each(([idx, remaining_time_el]) => {
      const sell_start_at = remaining_time_el.dataset.sell_start_at;

      // 유효하지 않은 시작일이면 타이머 등록하지 않음
      if (!sell_start_at) {
        return;
      }

      const changeRemainingTime = () => {
        // 시작일이 지났으면 종료
        if (isBefore(new Date(sell_start_at), new Date())) {
          // 타이머 삭제
          if (timers[idx]) {
            clearInterval(timers[idx]);
          }

          // coming soon 제거
          const coming_soon_el = $closest('.app-product-item__coming-soon', remaining_time_el);
          $hide(coming_soon_el);
          return;
        }

        const remain_time_infos = UtilS.differenceTimeInUnits(
          ['day', 'hour', 'minute', 'second'],
          new Date(sell_start_at),
          new Date(),
          true,
        );
        const { day, hour, minute, second } = remain_time_infos;
        remaining_time_el.innerText = `${day}D ${hour}H ${minute}M ${second}S`;
      };

      // 타이머 clear할 수 있도록 배열에 저장
      timers[idx] = setInterval(changeRemainingTime, 1000);
      changeRemainingTime();
    }),
  );
  return timers;
};

export const clearTimers = (timers) => {
  each((timer) => {
    if (timer) {
      clearInterval(timer);
    }
  })(timers);
};
